import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../utils/api';
import { useAuthStore } from '../store/authStore';
import { Card, CardContent } from './ui/card';
import { Clock, Star } from 'lucide-react';

export default function RecentlyViewed() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const [recentArtists, setRecentArtists] = useState([]);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (isAuthenticated && !hasFetched.current) {
      hasFetched.current = true;
      apiClient.get('/recently-viewed')
        .then(response => setRecentArtists(response.data))
        .catch(() => {/* Silent fail */});
    }
  }, [isAuthenticated]);

  if (!isAuthenticated || recentArtists.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold flex items-center gap-2">
          <Clock className="text-violet-400" size={20} />
          Recently Viewed
        </h2>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
        {recentArtists.map((item) => (
          <Card
            key={item.artist_id}
            className="glass-default border-white/10 min-w-[200px] max-w-[200px] cursor-pointer hover-lift"
            onClick={() => navigate(`/artist/${item.artist.artist_id}`)}
          >
            <div className="aspect-square relative overflow-hidden rounded-t-xl bg-gradient-to-br from-violet-500/20 to-fuchsia-500/20">
              {item.artist.media_urls?.[0] ? (
                <img
                  src={item.artist.media_urls[0]}
                  alt="Artist"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <Star className="w-8 h-8 text-violet-400/50" />
                </div>
              )}
            </div>
            <CardContent className="p-3">
              <p className="font-semibold truncate text-sm">
                {item.artist.bio?.split(' ').slice(0, 3).join(' ')}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
